"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataDescription = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const media_1 = require("../../../../../utils/media");
const Typography_1 = require("../../../../atoms/Typography");
const DataDescription = (0, styled_components_1.default)(Typography_1.H4) `
  display: inline;
  font-weight: 500;
  text-transform: uppercase;

  @media ${media_1.media.desktop} {
    display: block;
    text-transform: none;
    font-size: 18px;
    font-weight: 400;
  }
`;
exports.DataDescription = DataDescription;
